module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "tab"
  }, [(_vm.title != '') ? _c('li', {
    staticClass: "tab-item"
  }, [_c('a', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._l((_vm.tablist), function(tab) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('a', {
      key: tab.id,
      class: {
        active: _vm.currentName == tab.id
      },
      on: {
        "click": function($event) {
          _vm.tabSelected(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.name))])])
  }), _c('li', {
    staticClass: "floatr"
  }, [_vm._t("extentTab")], 2)], 2), _vm._t(_vm.currentName), _vm._t("common")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-792d55b3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-792d55b3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/tab-content.vue
// module id = 774
// module chunks = 0